import { jwtDecode } from 'jwt-decode';

import useAuth from '@frolight/hooks/useAuth';
import * as authenticationService from '@frolight/services/api/authenticationService';

const useRefreshToken = () => {

  const { setAuth } = useAuth();

  const refreshAccessToken = async (abortController) => {
    if (abortController.signal.aborted) {
      return { error: new Error('Aborted'), data: null };
    }

    try {
      const response = await authenticationService.refreshAccessToken(abortController);
      if (!response?.access_token) {
        throw new Error('No access token received!');
      }

      const decodedToken = jwtDecode(response.access_token);
      setAuth(prev => {
        return {
          ...prev,
          user: {
            id: decodedToken.sub,
            firstName: decodedToken.given_name,
            lastName: decodedToken.family_name,
            email: decodedToken.email,
            avatar: decodedToken.picture
          },
          memberships: decodedToken.memberships,
          roles: decodedToken.roles,
          accessToken: {
            token: response.access_token,
            type: response.token_type
          }
        };
      });

      return {
        error: null,
        data: response
      };
    } catch (err) {
      if (err.name === 'AbortError') {
        return { error: err, data: null };
      }
      return {
        error: err,
        data: null
      };
    }
  };

  return refreshAccessToken;

};

export default useRefreshToken;
